import { render, staticRenderFns } from "./TqBtnApprove.vue?vue&type=template&id=7d6e1026&scoped=true&"
import script from "./TqBtnApprove.vue?vue&type=script&lang=js&"
export * from "./TqBtnApprove.vue?vue&type=script&lang=js&"
import style0 from "./TqBtnApprove.vue?vue&type=style&index=0&id=7d6e1026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6e1026",
  null
  
)

export default component.exports